import { jsx as _jsx } from "react/jsx-runtime";
import { Copy } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { useToasts } from "@air/provider-toast";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import { COPY_URL_BUTTON } from "~/constants/testIDs";
export const CopyLinkButton = /*#__PURE__*/ memo((param)=>{
    let { onCopied, shareUrl, className } = param;
    const { showToast } = useToasts();
    const onClick = async ()=>{
        try {
            await window.navigator.clipboard.writeText(shareUrl);
            onCopied === null || onCopied === void 0 ? void 0 : onCopied(shareUrl);
            showToast("Link copied");
        } catch (_error) {
            showToast("Failed to copy link", {
                color: "red"
            });
        }
    };
    return /*#__PURE__*/ _jsx(Button, {
        "data-testid": COPY_URL_BUTTON,
        appearance: "filled",
        color: "blue",
        onClick: onClick,
        size: "extra-large",
        className: tailwindMerge("gap-1", className),
        prefix: /*#__PURE__*/ _jsx(Copy, {
            className: "size-6"
        }),
        children: "Copy link"
    });
});
CopyLinkButton.displayName = "CopyLinkButton";
